import { render, staticRenderFns } from "./ThemplateMedicalRecordPatient.vue?vue&type=template&id=4d40f4fa"
import script from "./ThemplateMedicalRecordPatient.vue?vue&type=script&lang=js"
export * from "./ThemplateMedicalRecordPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports